export default function Grid({ children, minWidth = "105px", gap = "8px", style }) {
  return (
    <div
      style={{
        display: "flex",
        flexWrap: "wrap",

        gap,
        width: "100%",
        ...style,
      }}
    >
      {children}
    </div>
  );
}